import {
  REIMBURSEMENT_LOADING,
  GET_REIMBURSEMENT,
  GET_REIMBURSEMENT_SUCCESS,
  GET_REIMBURSEMENT_FAIL,
  ADD_REIMBURSEMENT_SUCCESS,
  ADD_REIMBURSEMENT_FAIL,
  DELETE_REIMBURSEMENT_SUCCESS,
  DELETE_REIMBURSEMENT_FAIL,
  UPDATE_REIMBURSEMENT_SUCCESS,
  UPDATE_REIMBURSEMENT_FAIL,
  REIMBURSEMENT_RESET
} from "./actionType";

const INIT_STATE = {
  reimbursements: [],
  error: {},
};

const Reimbursement = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_REIMBURSEMENT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_REIMBURSEMENT:
          return {
            ...state,
            reimbursements: action.payload.data,
            isReimbursementCreated: false,
            isReimbursementSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_REIMBURSEMENT_FAIL:
      switch (action.payload.actionType) {
        case GET_REIMBURSEMENT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isReimbursementCreated: false,
            isReimbursementSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_REIMBURSEMENT: {
      return {
        ...state,
        isReimbursementCreated: false,
        loading: true,
      };
    }

    case REIMBURSEMENT_LOADING: {
      return {
        ...state,
        isReimbursementCreated: false,
        loading: true,
      };
    }

    case ADD_REIMBURSEMENT_SUCCESS:
      return {
        ...state,
        isReimbursementCreated: true,
        loading: false,
        reimbursements: [action.payload.data, ...state.reimbursements],
      };

    case ADD_REIMBURSEMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_REIMBURSEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        isReimbursementCreated: true,
        reimbursements: state.reimbursements.filter(
          reimbursement => reimbursement.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_REIMBURSEMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_REIMBURSEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        isReimbursementCreated: true,
        reimbursements: state.reimbursements.map(reimbursement =>
          reimbursement.id.toString() === action.payload.data.id.toString() ? { ...reimbursement, ...action.payload.data } : reimbursement
        ),
      };

    case UPDATE_REIMBURSEMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case REIMBURSEMENT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Reimbursement;